<template>
  <div class="relative">
    <div class="h-20 md:h-24 px-6 py-4 lg:px-20 flex justify-between fixed inset-0 bg-white z-40 border-b border-gray-200">
      <div class="xl:w-2/12 flex">
        <NuxtLink :to="localePath('/')" class="flex">
          <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="h-full cursor-pointer" src="/images/logo_nero.png"/>
        </NuxtLink>
      </div>
      <div class="hidden xl:flex xl:w-8/12 xl:justify-center xl:items-center gap-10">
        <MenuItem v-for="item in menuStore.menuItems" :key="item.id"
          @mouseover="uxStore.isOpenMenu = {}; uxStore.isOpenMenu[item.id] = true"
          :active="route.path === localePath(item.path)">
        <NuxtLink :to="localePath(item.path)">{{ $t(item.label) }}</NuxtLink>
        </MenuItem>
      </div>

      <div class="xl:w-2/12 xl:justify-end flex gap-2 items-center">
        <LanguageSelector class="hidden xl:block"></LanguageSelector>
        <Icon class="xl:hidden cursor-pointer shrink-0" name="mdi:menu"
          @click="uxStore.isOpenMenu = {}; uxStore.isOpenMobileMenu = !uxStore.isOpenMobileMenu"></Icon>
      </div>
    </div>

    <!--<div class="hidden xl:block">
      <div v-for="item in menuStore.menuItems" :key="item.id">
        <MenuSubmenu v-if="!!item.items" :id="item.id" :items="item.items"
          :class="{ 'transform -translate-y-[450px]': !uxStore.isOpenMenu[item.id], 'transform translate-y-0': uxStore.isOpenMenu[item.id] }">
        </MenuSubmenu>
      </div>
    </div>-->

    <!--Mobile menu-->
    <div class="fixed z-50" :class="{ 'inset-0': uxStore.isOpenMobileMenu }">
      <div :class="{ 'hidden': !uxStore.isOpenMobileMenu }"
        @click="uxStore.isOpenMenu = {}; uxStore.isOpenMobileMenu = !uxStore.isOpenMobileMenu"
        class="fixed inset-0 bg-gray-800 opacity-25 transition-none"></div>
      <nav :class="{ '-translate-x-full': !uxStore.isOpenMobileMenu, 'translate-x-0': uxStore.isOpenMobileMenu }" class="z-10 fixed top-0 left-0 bottom-0 flex flex-col w-full md:max-w-sm px-6 py-4 bg-white 
      border-r overflow-y-auto min-h-screen transition-transform duration-700 ease-in-out transform">
        <div class="flex items-center pb-4 border-b">
          <NuxtLink :to="localePath('/')">
            <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="cursor-pointer h-12 md:h-16" src="/images/logo_nero.png"/>
          </NuxtLink>
          <button class="ml-auto navbar-close"
            @click="uxStore.isOpenMenu = {}; uxStore.isOpenMobileMenu = !uxStore.isOpenMobileMenu">
            <svg class="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500" xmlns="http://www.w3.org/2000/svg"
              fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div class="overflow-x-clip">
          <div v-if="uxStore.isOpenMobileMenu" class="duration-700 ease-in-out transition-transform"
            :class="{ '-translate-x-full h-0 w-0 overflow-hidden': !showMobileSubmenu, 'translate-x-0': showMobileSubmenu }">
            <template v-for="item in menuStore.menuItems" :key="item.id">
              <!--<MenuMobileSubmenu v-if="!!item.items && uxStore.isOpenMenu[item.id]" :id="item.id" :items="item.items">
              </MenuMobileSubmenu>-->
            </template>
          </div>
          <div class="flex flex-col mt-4 gap-6 duration-700 ease-in-out transition-transform"
            :class="{ 'translate-x-full h-0 w-0 overflow-hidden': showMobileSubmenu, 'translate-x-0': !showMobileSubmenu }">
            <div class="mb-1" v-for="item in menuStore.menuItems">
              <NuxtLink v-if="!item.items" :to="localePath(item.path)">
                <MenuItem class="w-full" :chevron="false" :key="item.path"
                  :active="route.path === localePath(item.path)">
                {{ $t(item.label) }}
                </MenuItem>
              </NuxtLink>
              <div v-else>
                <MenuItem class="w-full" :chevron="false" :key="item.path"
                  @click="uxStore.isOpenMenu = {}; uxStore.isOpenMenu[item.id] = true"
                  :active="route.path === localePath(item.path)">
                {{ $t(item.label) }}
                </MenuItem>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-28 mt-auto text-xs">
          <div class="pt-6 w-full">
            <LanguageSelector></LanguageSelector>
          </div>
          <p class="py-2">&copy; {{ new Date().getFullYear() }}</p>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>

const uxStore = useUxStore();
const menuStore = useMenuStore();
const route = useRoute();

const showMobileSubmenu = computed(() => Object.keys(uxStore.isOpenMenu).some(key => uxStore.isOpenMenu[key]));

useHead({
  bodyAttrs: {
    class: computed(() => {
      if (uxStore.isOpenMobileMenu || uxStore.isOpenWelcomeModal) return 'overflow-hidden';
      return '';
    }),
  },
});

</script>

<style></style>